import { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useApi } from "../../api/APIContext";
import type { Company, Project } from "../../api/dto";
import { CompanyListTile } from "../../components/companies/CompanyListTile";
import { ContentContainer } from "../../components/content/ContentContainer";
import { PageHeader } from "../../components/content/PageHeader";
import { Input } from "../../components/form/Input";

interface CompanyWithSearchFields extends Company {
  childCompanies: Company[];
  parentCompanies: Company[];
  projects: Project[];
}

export const CompaniesListPage = () => {
  const [search, setSearch] = useState("");
  const { companies, projects } = useApi();
  const navigate = useNavigate();

  const filteredCompanies = useMemo(() => {
    const searchableCompanies: CompanyWithSearchFields[] = companies
      .filter((c) => !c.isArchived)
      .map((company) => {
        return {
          ...company,
          childCompanies: [company], // TODO: Different.
          parentCompanies: [],
          projects: projects.filter((p) => p.companyId === company.id && !p.isArchived),
        };
      });

    return searchableCompanies.filter(
      (company) =>
        company.name.toLowerCase().includes(search.toLowerCase()) ||
        company.alias?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [companies, projects, search]);

  return (
    <ContentContainer>
      <PageHeader>Bedrijven</PageHeader>
      <Input type={"text"} label={"Zoeken"} value={search} onChange={setSearch} />

      <div className={"grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4 mt-4"}>
        {filteredCompanies.map((company, i) => (
          <CompanyListTile
            company={company}
            key={i}
            onClick={() => {
              navigate(`/companies/${company.id}`);
            }}
          />
        ))}
      </div>
    </ContentContainer>
  );
};
